import React, { useEffect } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import ProtectedRoute from "./Common/ProtectedRoute";
import RequestLog from "./Common/RequestLog";
import ReadAloud from "./Common/ReadAloud";
import SSOLogin from "./SSOLogin"

// LOGIN
import FamilyLogin from "./LOGIN/FamilyLogin";
import SchoolLogin from "./LOGIN/SchoolLogin";
import ForgotPassword from "./LOGIN/ForgotPassword";
import LoggedOut from "./LOGIN/LoggedOut";
import SelectUser from "./LOGIN/SelectUser";

// MATHS DOCTOR
import Assessment from "./MathsDoctor/Assessment/Assessment";
import AssessmentComplete from "./MathsDoctor/Assessment/AssessmentComplete";
import ConfirmAssessment from "./MathsDoctor/Assessment/ConfirmAssessment";
import GenerateMDReportAndLP from "./MathsDoctor/Assessment/GenerateMDReportAndLP";
import ResumeAssessment from "./MathsDoctor/Assessment/ResumeAssessment";
import MovingReport from "./MathsDoctor/Reports/MovingReport";
import NavigationReport from "./MathsDoctor/Reports/NavigationReport";
import PDFReport from "./MathsDoctor/Reports/PDFReport";
import StillReport from "./MathsDoctor/Reports/StillReport";

// ENGLISH CHECK
import AssessmentEC from "./EnglishCheck/Assessment/AssessmentEC";
import ResumeECAssessment from "./EnglishCheck/Assessment/ResumeECAssessment";
import ConfirmECAssessment from "./EnglishCheck/Assessment/ConfirmECAssessment";
import GenerateECReportAndLP from "./EnglishCheck/Assessment/GenerateECReportAndLP";
import AssessmentECComplete from "./EnglishCheck/Assessment/AssessmentECComplete";

// MSR
import AllPurchases from "./STUDENT/MSR/AllPurchases";
import ChangeAvatar from "./STUDENT/MSR/ChangeAvatar";
import DoAgainPage from "./STUDENT/MSR/DoAgain";
import DoMore from "./STUDENT/MSR/DoMore";
import ExploreActivities from "./STUDENT/MSR/ExploreActivities";
import ModifyLessonPlan from "./STUDENT/MSR/ModifyLessonPlan";
import ModifyProfile from "./STUDENT/MSR/ModifyProfile";
import MSRReports from "./STUDENT/MSR/MSRReports";
import MyCompsCurrent from "./STUDENT/MSR/MyCompsCurrent";
import MyCompsPast from "./STUDENT/MSR/MyCompsPast";
import MyIncentives from "./STUDENT/MSR/MyIncentives";
import MyStore from "./STUDENT/MSR/MyStore";
import Profile from "./STUDENT/MSR/Profile";
import SearchActivities from "./STUDENT/MSR/SearchActivities";
import SkillBuildingGames from "./STUDENT/MSR/SkillBuildingGames";
import StudentActivityReport from "./STUDENT/MSR/StudentActivityReport";
import StudentMathsDoctorReport from "./STUDENT/MSR/StudentMathsDoctorReport";
import StudentEnglishCheckReport from "./STUDENT/MSR/StudentEnglishCheckReport";
import StudyRoom from "./STUDENT/MSR/StudyRoom";
import UserDiary from "./STUDENT/MSR/UserDiary";
import ViewAllGames from "./STUDENT/MSR/ViewAllGames";

// TUTORIALS
import AnswerSheet from "./STUDENT/Tutorials/AnswerSheet";
import ConfirmTest from "./STUDENT/Tutorials/ConfirmTest";
import Game from "./STUDENT/Tutorials/Game";
import Question from "./STUDENT/Tutorials/Question";
import QuestionCopy from "./STUDENT/TutorialsCopy/Question";
import Result from "./STUDENT/Tutorials/Result";
import SearchTests from "./STUDENT/Tutorials/SearchTests";
import Test from "./STUDENT/Tutorials/Test";
import Tutorial from "./STUDENT/Tutorials/Tutorial";
import TutorialCopy from "./STUDENT/TutorialsCopy/Tutorial";
import Timeout from "./Common/Timeout";

// import Brickwall from './STUDENT/MSR/stuu';
// import ErrorLogTable from './Common/ErrorLogTable';
const App: React.FC = () => {
  useEffect(() => {
    const handleResize = () => {
      document.body.style.height = `${window.innerHeight - 40}px`;
      document.body.style.width = `${window.innerWidth}px`;
    };

    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <Router>
      <ReadAloud />
      <Routes>
        {/* Public routes */}

        <Route path="/" element={<FamilyLogin />} />
        <Route path="/Login/SchoolLogin" element={<SchoolLogin />} />
        <Route path="/Login/ForgotPassword" element={<ForgotPassword />} />
        <Route path="/Login/LoggedOut" element={<LoggedOut />} />
        <Route path="/STUDENT/MSR/StudyRoom" element={<StudyRoom />} />
        <Route path="/RequestLog" element={<RequestLog />} />
        <Route path="/timeout" element={<Timeout />} />
        <Route path="/Login/SelectUser" element={<SelectUser />} />
        <Route path="/sso-login" element={<SSOLogin />} />
        {/* <Route path='/ErrorLogs' element={<ErrorLogTable />} /> */}
        

        {/* Protected routes wrapper */}
        <Route element={<ProtectedRoute />}>
          {/* LOGIN */}

          {/* MATHS DOCTOR */}
          <Route
            path="/MathsDoctor/Assessment/Assessment"
            element={<Assessment />}
          />
          <Route
            path="/MathsDoctor/Assessment/AssessmentComplete"
            element={<AssessmentComplete />}
          />
          <Route
            path="/MathsDoctor/Assessment/ConfirmAssessment"
            element={<ConfirmAssessment />}
          />
          <Route
            path="/MathsDoctor/Assessment/GenerateMDReportAndLP"
            element={<GenerateMDReportAndLP />}
          />
          <Route
            path="/MathsDoctor/Assessment/ResumeAssessment"
            element={<ResumeAssessment />}
          />
          <Route
            path="/MathsDoctor/Reports/MovingReport"
            element={<MovingReport />}
          />
          <Route
            path="/MathsDoctor/Reports/NavigationReport"
            element={<NavigationReport />}
          />
          <Route
            path="/MathsDoctor/Reports/PDFReport"
            element={<PDFReport />}
          />
          <Route
            path="/MathsDoctor/Reports/StillReport"
            element={<StillReport />}
          />

          {/* ENGLISH CHECK */}
          <Route
            path="/EnglishCheck/Assessment/AssessmentEC"
            element={<AssessmentEC />}
          />
          <Route
            path="/EnglishCheck/Assessment/ResumeECAssessment"
            element={<ResumeECAssessment />}
          />
          <Route
            path="/EnglishCheck/Assessment/ConfirmECAssessment"
            element={<ConfirmECAssessment />}
          />
          <Route
            path="/EnglishCheck/Assessment/GenerateECReportAndLP"
            element={<GenerateECReportAndLP />}
          />
          <Route
            path="/EnglishCheck/Assessment/AssessmentECComplete"
            element={<AssessmentECComplete />}
          />

          {/* MSR */}
          <Route path="/STUDENT/MSR/AllPurchases" element={<AllPurchases />} />
          <Route path="/STUDENT/MSR/ChangeAvatar" element={<ChangeAvatar />} />
          <Route path="/STUDENT/MSR/DoAgainPage" element={<DoAgainPage />} />
          <Route path="/STUDENT/MSR/DoMore" element={<DoMore />} />
          <Route
            path="/STUDENT/MSR/ExploreActivities"
            element={<ExploreActivities />}
          />
          <Route
            path="/STUDENT/MSR/ModifyLessonPlan"
            element={<ModifyLessonPlan />}
          />
          <Route
            path="/STUDENT/MSR/ModifyProfile"
            element={<ModifyProfile />}
          />
          <Route path="/STUDENT/MSR/MSRReports" element={<MSRReports />} />
          <Route
            path="/STUDENT/MSR/MyCompsCurrent"
            element={<MyCompsCurrent />}
          />
          <Route path="/STUDENT/MSR/MyCompsPast" element={<MyCompsPast />} />
          <Route path="/STUDENT/MSR/MyIncentives" element={<MyIncentives />} />
          <Route path="/STUDENT/MSR/MyStore" element={<MyStore />} />
          <Route path="/STUDENT/MSR/Profile" element={<Profile />} />
          <Route
            path="/STUDENT/MSR/SearchActivities"
            element={<SearchActivities />}
          />
          <Route
            path="/STUDENT/MSR/SkillBuildingGames"
            element={<SkillBuildingGames />}
          />
          <Route
            path="/STUDENT/MSR/StudentActivityReport"
            element={<StudentActivityReport />}
          />
          <Route
            path="/STUDENT/MSR/StudentMathsDoctorReport"
            element={<StudentMathsDoctorReport />}
          />
          <Route
            path="/STUDENT/MSR/StudentEnglishCheckReport"
            element={<StudentEnglishCheckReport />}
          />
          <Route path="/STUDENT/MSR/UserDiary" element={<UserDiary />} />
          <Route path="/STUDENT/MSR/ViewAllGames" element={<ViewAllGames />} />

          {/* TUTORIALS */}
          <Route
            path="/STUDENT/Tutorials/AnswerSheet"
            element={<AnswerSheet />}
          />
          <Route
            path="/STUDENT/Tutorials/ConfirmTest"
            element={<ConfirmTest />}
          />
          <Route path="/STUDENT/Tutorials/Game" element={<Game />} />
          <Route path="/STUDENT/Tutorials/Question" element={<Question />} />
          <Route path="/STUDENT/TutorialsCopy/Question" element={<QuestionCopy />} />
          <Route path="/STUDENT/Tutorials/Result" element={<Result />} />
          <Route
            path="/STUDENT/Tutorials/SearchTests"
            element={<SearchTests />}
          />
          <Route path="/STUDENT/Tutorials/Test" element={<Test />} />
          <Route path="/STUDENT/Tutorials/Tutorial" element={<Tutorial />} />
          <Route path="/STUDENT/TutorialsCopy/Tutorial" element={<TutorialCopy />} />
        </Route>
      </Routes>
    </Router>
  );
};

export default App;